/**
 * Figures as the BI dashboards write them (CU-869fmjzrh S2; first in "Season vs last year", CU-869fmhmx8): money
 * rounded to the unit in the account currency, signed amounts and percentages, ordinals, initials. Alias-free.
 */

export function money(n, code = 'EUR') {
	if (n === null || n === undefined || Number.isNaN(n)) return '—'
	const v = Math.round(Math.abs(n))
	try {
		return new Intl.NumberFormat('en-GB', { style: 'currency', currency: code || 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(v)
	} catch {
		return `${code || ''} ${v.toLocaleString('en-GB')}`.trim()
	}
}

export function signedMoney(n, code) {
	const r = Math.round(n)
	return r === 0 ? money(0, code) : `${r > 0 ? '+' : '−'}${money(r, code)}`
}

export function signedPct(p) {
	if (p === null || p === undefined || Number.isNaN(p)) return ''
	const r = Math.round(p * 1000) / 10
	return r === 0 ? '0%' : `${r > 0 ? '+' : '−'}${Math.abs(r).toFixed(1)}%`
}

export function ordinal(n) {
	const s = n % 100 >= 11 && n % 100 <= 13 ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th'
	return `${n}${s}`
}

export const initials = name => String(name || '').split(/\s+/).filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase()
